import { HeadingXSmall, LabelLarge } from 'baseui/typography';
import { BacnetPropertyMappingsView } from './BacnetPropertyMappingsView';
import { BacnetObjectMappingsView } from './BacnetObjectMappingsView';


const BacnetMappings = (props: { objectId: string, resourceGroupId: string }) => {
    return (
        <>
            <HeadingXSmall>BACnet Mappings</HeadingXSmall>

            <BacnetObjectMappingsView resourceGroupId={props.resourceGroupId} objectId={props.objectId} />
            <BacnetPropertyMappingsView resourceGroupId={props.resourceGroupId} objectId={props.objectId}></BacnetPropertyMappingsView>
        </>
    )
}

export default BacnetMappings

